(function () {
  const PUFFY_GIFT_PRODUCT_ID = 10798519386422;
  const PUFFY_GIFT_HANDLE = 'puffy-stickers-gift';
  const PUFFY_GIFT_SKU = 'GWP0826';

  let dedupeTimer = null;
  let dedupeRunning = false;

  function isPuffyGiftLine(item) {
    if (!item) return false;
    const sku = String(item.sku || '').toUpperCase();
    return (
      item.product_id === PUFFY_GIFT_PRODUCT_ID ||
      item.handle === PUFFY_GIFT_HANDLE ||
      sku === PUFFY_GIFT_SKU
    );
  }

  function refreshCartUI() {
    document.querySelectorAll('cart-items, cart-drawer-items').forEach((el) => {
      if (typeof el.onCartUpdate === 'function') el.onCartUpdate();
    });

    const bubble = document.getElementById('cart-icon-bubble');
    if (!bubble || !window.routes?.cart_url) return;

    fetch(`${window.routes.cart_url}?section_id=cart-icon-bubble`)
      .then((response) => response.text())
      .then((html) => {
        const section = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
        if (section) bubble.innerHTML = section.innerHTML;
      })
      .catch(() => {});
  }

  function dedupePuffyGiftLines() {
    if (dedupeRunning || window.CartLock?.isBusy()) return Promise.resolve(false);

    dedupeRunning = true;

    return fetch('/cart.js')
      .then((response) => response.json())
      .then((cart) => {
        const gifts = (cart.items || []).filter(isPuffyGiftLine);
        const totalQty = gifts.reduce((sum, item) => sum + item.quantity, 0);

        if (gifts.length === 0 || (gifts.length === 1 && totalQty <= 1)) {
          return false;
        }

        const updates = {};
        gifts.forEach((item, index) => {
          updates[item.key] = index === 0 ? 1 : 0;
        });

        return fetch(window.routes.cart_update_url, {
          ...fetchConfig(),
          body: JSON.stringify({ updates }),
        }).then((response) => {
          if (!response.ok) throw new Error('Failed to dedupe Puffy Stickers gift');
          refreshCartUI();
          return true;
        });
      })
      .catch((error) => {
        console.error(error);
        return false;
      })
      .finally(() => {
        dedupeRunning = false;
      });
  }

  function schedulePuffyGiftDedupe() {
    if (dedupeTimer) clearTimeout(dedupeTimer);
    dedupeTimer = setTimeout(() => {
      dedupeTimer = null;
      dedupePuffyGiftLines();
    }, 400);
  }

  window.schedulePuffyGiftDedupe = schedulePuffyGiftDedupe;

  window.addEventListener('cart:idle', schedulePuffyGiftDedupe);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedulePuffyGiftDedupe);
  } else {
    schedulePuffyGiftDedupe();
  }
})();
